import imagefallback from '@loyal_images/products/product_placeholder.png'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactImageFallback from 'react-image-fallback'
import { Link } from 'react-router-dom'
class CardStore extends Component {
  render () {
    return (
      <Link to={'/comunidade-iupp/company/' + this.props.chain.id + '/store/' + this.props.id} tabIndex={0} className='card card-bairro mt-2' title={`Vai para ${this.props.chain.name}`}>
        <div className='bordered radius border-color-ui-3 bg-white d-flex-mob'>
          <div className='figure-mBairo d-flex justify-content-center mt-2 mb-2'>
            <ReactImageFallback
              src={this.props.urlThumbnail}
              fallbackImage={imagefallback}
              initialImage={imagefallback}
              alt={this.props.chain.name}
              className='mx-auto'
            />
          </div>
          <div className='div-mob h-auto'>
            <div className='col-12 mt-0 px-2'>
              <p className='txt-body w-100 color-ui-black txt-font-body mb-1 text-bfits-list'>{this.props.chain.name}</p>
              <p className='text-style-benific lineH29'>
                {this.props.name}
              </p>
              <strong className='text-benific-pq'>{ this.props.quantityOffers > 0 ? this.props.quantityOffers + ' ofertas' : 'Nenhum oferta' }</strong>
              <strong className='text-benific-pq colorBairro'>{ this.props.location ? (this.props.place.location.distance / 1000).toFixed(1) + ' km - ' + this.props.place.address.city : '' } </strong>
            </div>
          </div>
        </div>
      </Link>
    )
  }
}

CardStore.propTypes = {
  id: PropTypes.string,
  chain: PropTypes.object,
  quantityOffers: PropTypes.number,
  name: PropTypes.string,
  urlThumbnail: PropTypes.string,
  place: PropTypes.shape({
    location: PropTypes.shape({
      distance: PropTypes.number
    }),
    address: PropTypes.shape({
      city: PropTypes.string,
      uf: PropTypes.string
    })
  }),
  location: PropTypes.bool
}
export default CardStore



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Card/CardStore.js